module.exports = __webpack_public_path__ + "img/scene5-6.7d6a110b.jpg";